<template>
  <div class="corpoBoxUpload">
    <v-text-field
      readonly
      :disabled="disabled"
      :required="required"
      v-model="fakeFale"
      :label="label"
      append-icon="search"
      @click:append="procurarImagem();"
      @click="procurarImagem()"
      ref="campoText"
      :error="erros"
      :error-messages="errorMessages"
      :rules="[v => validaCampoVazio(!!v) || 'Este campo é obrigatório.']"
    ></v-text-field>
    <input style type="file" :accept="accept" ref="campoFile" @change="handleFileUpload()">
  </div>
</template>
<script>
export default {
  name: "upload-file",
  props: {//Propriedades que o objeto recebe como parametro
    label: String,
    accept: String,
    disabled:{
      type: Boolean,
    },
    required:{
      type: Boolean,
    },
    tamanhoMaximo: {
      type: [String],
      default: "20MB"
    }
  },
  data() {//Declaracao de variaveis
    return {
      file: "",
      fakeFale: "",
      erros: false,
      errorMessages: null
    };
  },
   created() /*Metodo de start do componente*/{

   },
  methods: {//Declaracao de todos os metodos
    validaCampoVazio(v){

if(!v && this.required) return false;
else  return true
    },
    setErros(errorMessages) {
      this.$emit("input", null);
      this.erros = true;
      this.fakeFale = null;
      this.errorMessages = errorMessages;
      return false;
    },
    setTamanhoMaximo() {
      var tipo = this.tamanhoMaximo.substring(this.tamanhoMaximo.length - 2);
      var tamanho = this.tamanhoMaximo.split(tipo).join("");
      tipo = tipo.toLocaleUpperCase();
      if (tipo === "KB") {
        return tamanho * 1024;
      }

      if (tipo === "MB") {
        return tamanho * 1024 * 1024;
      }
      if (tipo === "GB") {
        return tamanho * 1024 * 1024 * 1024;
      }
      //Se não encontrar
      return tamanho
    },
    procurarImagem() {
      var elem = this.$refs.campoFile;
      elem.click();
    },
    handleFileUpload() {
      var originalFile = this.$refs.campoFile.files[0];
      this.erros = false;
      this.errorMessages = null;

      this.$refs.campoText.focus();

      var reader = new FileReader();
      var typeArquivo = originalFile.name.substr(
        originalFile.name.lastIndexOf(".")
      );
      

      reader.onload = e => {
        let base64 = e.target.result.split(";")[1].split(",")[1];
        this.file = {
          base64: base64,
          filename: originalFile.name,
          filetype: originalFile.type
        };

        this.fakeFale = originalFile.name;

        this.$emit("input", this.file);
      };

      reader.onerror = function(error) {
        alert(error);
      };

      if (originalFile) {        
        const charact = originalFile.name;        
        const arrChar = ["]","[","{","}",";",":",">","<","/","|","@","$","%","+","=","*","&","(",")","!","#","?","©"];

        const contains = arrChar.some(element => {
          if (charact.includes(element)) {
            return true;
          }

          return false;
        });
      
        if(contains) {
          return this.setErros(
            "O nome do arquivo não pode conter caracteres especiais."
          );
        }

        if (originalFile.size > this.setTamanhoMaximo()) {
          return this.setErros(
            "O arquivo execede o tamanho máximo de " + this.tamanhoMaximo
          );
        }

        if (this.accept) {
          if (this.accept.indexOf(typeArquivo) === -1) {
            return this.setErros("O arquivo não é dos tipos " + this.accept);
          }
        }

        if (originalFile.size <= this.setTamanhoMaximo()) {
          reader.readAsDataURL(originalFile);
        } else {
          this.$emit("input", null);
          this.erros = true;
          this.errorMessages = "Arquivo Inválido";
        }
      }
      return ""
    }
  }
};
</script>

<style>
.corpoBoxUpload {
  position: relative;
}

.corpoBoxUpload [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.corpoBoxUpload .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.corpoBoxUpload .v-text-field__slot {
  border-right: 0;
}

.corpoBoxUpload .v-input__icon.v-input__icon--append {
  align-self: center !important;
  min-height: 50px;
  border: solid 1px #eee;
  border-left: none;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.corpoBoxUpload .v-icon {
  padding: 13px 0 0 0;
}
</style>